import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import { VF_ADMIN_ROLE_ID, allTranslations } from "../../constants/constant";
import { Service } from "../../services/service";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setHeader } from "../../reduxSlices/headerSlice";
import ContentLoader from "../../components/loader/ContentLoader";
import styles from "./ConfigureTranslationPage.module.css";
import CustomAutocomplete from "../../components/autocomplete/Autocomplete";
import { updateTranslation } from "../../reduxSlices/translationSlice";
const service = new Service();

const ConfigureTranslationPage = () => {
  const dispatch = useDispatch();
  const selectedOrg = localStorage.getItem("selectedOrg");
  const parseOrg = JSON.parse(selectedOrg);

  const [loader, setLoader] = useState(false);
  const [organizationOptions, setOrganizationOptions] = useState([]);
  const [organization, setOrganization] = useState(parseOrg);

  const userData = useSelector((state) => state?.user);
  const userRole = userData?.userRoleId;
  const userOrg = userData?.organisation;
  const isVfAdmin = userRole?.includes(VF_ADMIN_ROLE_ID);
  const loading = useSelector((state) => state.translation.loading);

  console.log("selectedOrg>>>>", parseOrg);

  useEffect(() => {
    const fetchOrganization = async () => {
      setLoader(true);
      let url = `/api/Organization/OrganizationMaster`;
      const user_token = localStorage.getItem("bb_access_token");
      try {
        let data = await service.newGetApi(url, {}, user_token);
        let resp = data.data;
        console.log("resp", resp);
        setOrganizationOptions(resp);
        setLoader(false);
      } catch (err) {
        console.log(err);
        setLoader(false);
      }
    };
    fetchOrganization();
  }, []);

  useEffect(() => {
    if (isVfAdmin) return;
    setOrganization({ ...userOrg });
    localStorage.setItem("selectedOrg", JSON.stringify({ ...userOrg }));
  }, []);

  useEffect(() => {
    dispatch(
      setHeader({
        page: "configure-translations",
        title: "Configure Translations",
        subTitle:
          "Please select the organisation to configure available translations for the organisation and its users",
      })
    );
  }, []);

  const getOrgLabel = (option) => option?.organizationName;

  const handleAutoCompleteChange = (name, value) => {
    setOrganization({ ...value });
    localStorage.setItem("selectedOrg", JSON.stringify({ ...value }));
  };

  const handleClickTranslation = (item) => {
    localStorage.setItem("transalationId", item?.transalationId);
    dispatch(updateTranslation({}));
  };

  if (loading || loader) return <ContentLoader />;

  return (
    <>
      {isVfAdmin && (
        <Box
          component="form"
          sx={{
            "& > :not(style)": { marginBottom: "40px", width: "520px" },
          }}
          noValidate
          autoComplete="off"
        >
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <label style={labelStyle}>
              Organisation<sup style={requiredAr}>*</sup>
            </label>
            <CustomAutocomplete
              options={organizationOptions}
              value={organization}
              onChange={(e, value) => {
                if (value === null) {
                  value = {
                    organizationId: "",
                    organizationName: "",
                  };
                }
                handleAutoCompleteChange("organization", value);
              }}
              getOptionLabel={getOrgLabel}
              placeholder="Select organisation..."
            />
          </Box>
        </Box>
      )}
      {Object.keys(organization?.organizationName)?.length > 0 && (
        <div className={styles.mainDiv}>
          {allTranslations?.map((item, i) => (
            <div className={styles.parentDiv} key={i}>
              <Link
                to={item.navigate}
                onClick={() => handleClickTranslation(item)}
                style={{ textDecoration: "none" }}
              >
                <div className={styles.cardContainer}>
                  <div className={styles.title}>{item?.title}</div>
                  <div className={styles.lastUpdatedSep1}>
                    {item?.description}
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default ConfigureTranslationPage;

const requiredAr = {
  color: "#CF4500",
  fontSize: "13px",
  verticalAlign: "baseline",
};

const labelStyle = {
  fontSize: "14px",
  letterSpacing: "-0.02em",
  fontWeight: 600,
  fontFamily: "Montserrat",
  color: "#282828",
  textAlign: "left",
  marginBottom: "8px",
};
